import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { TutorialTooltipGroupContext } from '../util/contexts'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class TutorialTooltipGroup extends Component {
  static propTypes = {
    fade: PropTypes.bool,
    elmId: PropTypes.string,
    children: PropTypes.node.isRequired,
    childRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }

  static contextType = TutorialTooltipGroupContext

  render() {
    const { children, childRef, elmId, fade } = this.props
    const { showTooltip, handleClose } = this.context

    return showTooltip ? (
      <div data-elm-id={`${elmId}_tooltip_group`}>
        {fade && <div className={cx('dimmer')} onClick={handleClose} />}
        <div className={cx('show')} ref={childRef}>
          {children}
        </div>
      </div>
    ) : (
      <div ref={childRef}>{children}</div>
    )
  }
}

export default TutorialTooltipGroup
